import { render, staticRenderFns } from "./CreateDocumento.vue?vue&type=template&id=6ba4b7aa"
import script from "./CreateDocumento.vue?vue&type=script&lang=js"
export * from "./CreateDocumento.vue?vue&type=script&lang=js"
import style0 from "./CreateDocumento.vue?vue&type=style&index=0&id=6ba4b7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports